/* unplugin-vue-components disabled */import { render } from "./files-drop.vue?vue&type=template&id=355b0121&scoped=true"
import script from "./files-drop.vue?vue&type=script&lang=js"
export * from "./files-drop.vue?vue&type=script&lang=js"

import "./files-drop.vue?vue&type=style&index=0&id=355b0121&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355b0121"],['__file',"src/pages/files/files-drop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "355b0121"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('355b0121', __exports__)) {
    api.reload('355b0121', __exports__)
  }
  
  module.hot.accept("./files-drop.vue?vue&type=template&id=355b0121&scoped=true", () => {
    api.rerender('355b0121', render)
  })

}


export default __exports__